<div [formGroup]="form">
  <div class="mat-form-field-infix  w-100">
    <ngx-intl-tel-input [cssClass]="'phoneNumber'" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
      [searchCountryFlag]="true" [searchCountryField]="[
        SearchCountryField.Iso2,
        SearchCountryField.Name
      ]" [selectFirstCountry]="false" [selectedCountryISO]="form.controls['country'].value" [maxLength]="15" [phoneValidation]="false"
      [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National" name="number"
      formControlName="number">
    </ngx-intl-tel-input>
    <div *ngIf="submitted && contactFormValues['number'].errors">
      <div *ngIf="contactFormValues['number'].errors?.['required']" class="err-mssg">
        <em class="fas fa-exclamation-circle mr-2"></em>Number is required
      </div>
      <div *ngIf="!contactFormValues['number'].errors?.['required'] && contactFormValues['number'].errors" class="err-mssg">
        <em class="fas fa-exclamation-circle mr-2"></em>Enter valid phone number
      </div>
    </div>
  </div>
  <div class="mat-form-field-infix w-100">
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email">
      <ng-container *ngIf="submitted && contactFormValues['email'].errors">
        <mat-error *ngIf="contactFormValues['email'].errors?.['required']">
          <em class="fas fa-exclamation-circle mr-2"></em>Email is required
        </mat-error>
        <mat-error *ngIf="contactFormValues['email'].errors?.['pattern']">
          <em class="fas fa-exclamation-circle mr-2"></em>Enter a valid email address
        </mat-error>
      </ng-container>
    </mat-form-field>
  </div>
</div>